import Layout from '@/views/layout/Layout'

const cmsAlbumRoute = {
  path: '/cms/ad',
  component: Layout,
  redirect: '/cms/ad/baidu',
  name: 'cms.ad',
  meta: { title: '推广管理', icon: 'total-week' },
  children: [
    {
      path: 'baidu',
      name: 'cms.ad.baidu',
      component: () => import('@/views/cms/ad/baidu'),
      meta: { title: '百度推广', icon: 'order' }
    },
    {
      path: 'weixin',
      name: 'cms.ad.weixin',
      component: () => import('@/views/cms/ad/weixin'),
      meta: { title: '微信推广', icon: 'order-return-reason' }
    }
  ]
}

export default cmsAlbumRoute



// WEBPACK FOOTER //
// ./src/router/module/cmsAd.js